<template>
  <div class="flights-search">
    <div class="relative rounded-2xl h-[600px] md:h-[550px] xl:h-[426px] flex flex-col justify-end">
      <img src="/images/banner-puerto-de-venecia.webp" alt="Vista panorámica del puerto de Venecia" class="h-full object-cover">
      <div class="floating-container">
        <h1 class="heading-1 text-white lg:w-4/6">{{ $t('searcher.back_same_day') }}</h1>
        <app-searcher-wrapper class="mt-5">
          <div class="flex mb-2">
            <button @click="handleSearchTypeButton(1)" class="rounded-xlg px-4 py-3 font-bold bg-white mr-3"
              :class="{ 'opacity-60': searchType !== 1 }">{{
                $t('searcher.by_destiny') }}</button>
            <button @click="handleSearchTypeButton(0)" class="rounded-xlg px-4 py-3 font-bold bg-white"
              :class="{ 'opacity-60': searchType !== 0 }">{{
                $t('searcher.by_date') }}</button>
          </div>
          <div class="search-card">
            <app-search-form class="" :searchType="searchType"></app-search-form>
          </div>
        </app-searcher-wrapper>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import prependCustomIcons from '../../utils/mixins/prependCustomIcons';
import replaceArrows from '../../utils/mixins/replaceArrows';
import SearcherWrapper from './components/SearcherWrapper.vue';

export default {
  mixins: [prependCustomIcons, replaceArrows],
  components: {
    'app-searcher-wrapper': SearcherWrapper
  },
  data: () => ({
    searchType: 1,
  }),
  methods: {
    handleSearchTypeButton(value) {
      this.searchType = value;
      this.$nextTick(() => {
        this.prependCustomIcons();
        this.replaceArrows();
      });
    }
  },
};
</script>

<style lang="scss"></style>
